module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Create Your Starting Layers")]), _vm._v(" "), _c('md-list', _vm._l((_vm.project.layers), function(layer) {
    return _c('layer-lite', {
      key: layer.id,
      attrs: {
        "layer": layer
      },
      on: {
        "deleteLayer": _vm.deleteLayer
      }
    })
  })), _vm._v(" "), _c('layer-new', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addLayer": _vm.addLayer
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce53fa8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/modals/create-project/layers.vue
// module id = 680
// module chunks = 2